





































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SkeletonText extends Vue {
  @Prop({ default: 100 }) readonly maxWidth!: number;
  @Prop({ default: 80 }) readonly minWidth!: number;
  @Prop({ default: '1rem' }) readonly height!: string;
  @Prop({ default: null }) readonly width!: string;
  @Prop({ default: 'block' }) readonly display!: string;
  @Prop({ default: '7px', type: String }) readonly borderRadius!: string;

  get computedWidth() {
    if (this.width) {
      return this.width;
    }

    return `${Math.floor((Math.random() * (this.maxWidth - this.minWidth)) + this.minWidth)}%`;
  }

  get skeletonStyles() {
    return {
      display: this.display,
      height: this.height,
      width: this.computedWidth,
      borderRadius: this.borderRadius,
    };
  }
}
